import script from "./instrution.vue?vue&type=script&setup=true&lang=js"
export * from "./instrution.vue?vue&type=script&setup=true&lang=js"

import "./instrution.vue?vue&type=style&index=0&id=6a2b1696&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a2b1696"]])

export default __exports__